import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import {HealthInsuranceService} from '../../../services/health-insurance.service';
import {HealthRequest, PersianKeyValue, HealthMethods} from '../../../model/SamanHealthFamilyModels';

import {ActivatedRoute, Router} from '@angular/router';
import {StaticMethods} from '../../../model/GeneralModels';

@Component({
  selector: 'app-new-sub-request',
  templateUrl: './new-sub-request.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class NewSubRequestComponent implements OnInit {
  basicInsuranceList = ['ارتباط با انترنت قطع است'];
  relationList = [];
  genderList: string[];
  subRequestsList: any[];
  me: HealthRequest;
  partner: HealthRequest;
  BMI = 0;
  clientKey: string;
  subRequestForm = this.formBuilder.group({
    insurance: [''],
    relation: ['', Validators.required],
    gender: ['', Validators.required],
    height: ['', Validators.required],
    weight: ['', Validators.required],
    birthday: ['', Validators.required],
    BMI: [{value: '', disabled: true}, Validators.required]
  });
  translation: any = {};

  constructor(private healthInsuranceServices: HealthInsuranceService, private formBuilder: FormBuilder,
              private router: Router, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    if (StaticMethods.checkState(this.router, ['basicInformation', 'subRequestList'],
      ['/health/family/basic-information', 'health/family/new-request'])) {
      this.subRequestsList = history.state.subRequestList;
      console.log('subRequestList : ' + this.subRequestsList + '');
      if (!this.subRequestsList) {
        this.subRequestsList = [];
      }
      this.healthInsuranceServices.getBasicInsuranceList().subscribe(
        response => {
          if (response.success) {
            this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
            this.basicInsuranceList = response.data.basicInsuranceList;
          }
        });
      this.genderList = ['MALE', 'FEMALE'];
      this.relationList = ['ME', 'PARTNER', 'CHILD'];
      this.subRequestsList.forEach(subRequest => {
        console.log(subRequest);
        console.log(subRequest.relation);
        switch (subRequest.relation) {
          case 'PARTNER':
            this.partner = new HealthRequest(subRequest.birthday, subRequest.insurance, subRequest.gender, subRequest.relationship,
              subRequest.weight, subRequest.height);
            this.relationList = this.relationList.filter((value, index, arr) => {
              return value !== 'PARTNER';
            });
            break;
          case 'ME':
            this.me = new HealthRequest(subRequest.birthday, subRequest.insurance, subRequest.gender, subRequest.relationship,
              subRequest.weight, subRequest.height);
            this.relationList = this.relationList.filter((value, index, arr) => {
              return value !== 'ME';
            });
            break;
        }
      });
      if (!this.me && !this.partner) {
        this.relationList = this.relationList.filter((value, index, arr) => {
          return value !== 'CHILD';
        });
      }
    }
  }

  calculateBMI() {
    if ((!this.subRequestForm.controls.height.value) ||
      (!this.subRequestForm.controls.weight.value)) {
      this.subRequestForm.controls.BMI.patchValue('');
    } else {
      console.log('weight', this.subRequestForm.controls.weight.value);
      console.log('height power 2', Math.pow(this.subRequestForm.controls.height.value / 100, 2));
      this.subRequestForm.controls.BMI.patchValue(
        Math.round(
          this.subRequestForm.controls.weight.value / Math.pow(this.subRequestForm.controls.height.value / 100, 2)
        )
      );
      console.log('bmi', this.BMI);
    }
  }

  refreshLists() {
    const subRequest = this.subRequestForm.value;
    if (this.me && subRequest.relation === 'PARTNER') {
      this.genderList = this.genderList.filter((value, index, arr) => {
        return value !== this.me.gender();
      });
      this.subRequestForm.patchValue({
        gender: this.genderList[0]
      });
    } else {
      if (this.partner && subRequest.relation === 'ME') {
        this.genderList = this.genderList.filter((value, index, arr) => {
          return value !== this.partner.gender();
        });
        this.subRequestForm.patchValue({
          gender: this.genderList[0]
        });
      }
    }
  }

  addNewSubRequest() {
    console.warn(this.subRequestForm);
    if (this.subRequestForm.valid) {
      const value = this.subRequestForm.value;
      this.subRequestsList[this.subRequestsList.length] = this.subRequestForm.value;
      this.router.navigate(['/health/family/new-request'],
        {
          state: {
            subRequestList: this.subRequestsList,
            basicInformation: history.state.basicInformation
          }
        });
    }
  }
}

